import React from "react";
import PropTypes from "prop-types";
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ApprovalStepTimeline from "./ApprovalStepTimeline";

const ApprovalProgressPanel = ({ steps, usersMap, policySnapshot }) => {
  const sortedSteps = steps
    ? [...steps].sort(
        (a, b) => (a.step_index ?? a.id ?? 0) - (b.step_index ?? b.id ?? 0)
      )
    : [];

  const remaining = sortedSteps.filter(
    (s) => s.status !== "approved" && s.status !== "rejected"
  ).length;

  return (
    <div className="bg-card border border-card-bd rounded-card p-5">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <FontAwesomeIcon
            icon={icon({
              name: "list-check",
              family: "sharp",
              style: "light",
            })}
            className="text-text-2 text-sm"
          />
          <h3 className="text-sm font-semibold text-text">
            Approval Progress
          </h3>
        </div>
        {remaining > 0 && (
          <span className="text-xs text-text-2 pr-3">
            {remaining} approval{remaining === 1 ? "" : "s"} remaining
          </span>
        )}
      </div>

      <ApprovalStepTimeline steps={steps} usersMap={usersMap} policySnapshot={policySnapshot} />
    </div>
  );
};

ApprovalProgressPanel.propTypes = {
  steps: PropTypes.array,
  usersMap: PropTypes.object,
  policySnapshot: PropTypes.object,
};

export default ApprovalProgressPanel;
